import {
  validateAddressBuilding,
  validateAddressCity,
  validateAddressPrefectureCode,
  validateAddressStreet,
  validatePhoneMobile,
  validatePhoneTel,
  validatePostCode,
} from './MembersValidation'

export type ValidationAddressInput = {
  postCode: string
  addressPrefectureCode: string
  addressCity: string
  addressStreet: string
  addressBuilding: string
  phoneMobile: string
  phoneTel: string
}

export type ValidationAddressResultDetail = {
  [K in keyof ValidationAddressInput]: string[]
}

export type ValidationAddressResult = {
  hasError: boolean
  errors: ValidationAddressResultDetail
}

export const validateMemberAddressInput = (
  input: ValidationAddressInput,
): ValidationAddressResult => {

  const details: ValidationAddressResultDetail = {
    postCode: validatePostCode(input.postCode),
    addressPrefectureCode: validateAddressPrefectureCode(input.addressPrefectureCode),
    addressCity: validateAddressCity(input.addressCity),
    addressStreet: validateAddressStreet(input.addressStreet),
    addressBuilding: validateAddressBuilding(input.addressBuilding),
    phoneMobile: validatePhoneMobile(input.phoneMobile),
    phoneTel: validatePhoneTel(input.phoneTel),
  }

  const hasError =
    Object.values(details)
      .map(errorArray => errorArray.length)
      .some(length => length > 0)

  return {
    hasError: hasError,
    errors: details,
  }
}
